import AddToWatchlist from './AddToWatchlist.js';
import enhance from './enhancer';

export default enhance(AddToWatchlist);
